module.exports = '4.13.0';



// WEBPACK FOOTER //
// ./src/version.js